"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const AccountNumberTag_1 = __importDefault(require("../datastore/models/AccountNumberTag"));
const Utils_1 = __importDefault(require("./Utils"));
var AccountNumberTagUtils;
(function (AccountNumberTagUtils) {
    function accountNumberTagExistsForItem(accountItem, accountNumberTags) {
        return !!accountNumberTags.find(it => it.tag_id === accountItem.tag_id && it.account_number === accountItem.account_number);
    }
    AccountNumberTagUtils.accountNumberTagExistsForItem = accountNumberTagExistsForItem;
    function generateNewAccountNumberTags(accountItems, existingAccountNumberTags) {
        return accountItems.reduce((accum, item) => {
            if (item.account_number && item.tag_id && !accountNumberTagExistsForItem(item, accum) && !accountNumberTagExistsForItem(item, existingAccountNumberTags)) {
                return accum.concat(new AccountNumberTag_1.default({
                    tag_id: item.tag_id,
                    account_number: item.account_number,
                }));
            }
            return accum;
        }, []);
    }
    AccountNumberTagUtils.generateNewAccountNumberTags = generateNewAccountNumberTags;
    function addTagsToAccountItems(monthOrMonths, tagsMap, accountNumberTagsMap) {
        const months = [].concat(monthOrMonths);
        const anToTagMap = {};
        Object.keys(accountNumberTagsMap).forEach((key) => {
            anToTagMap[key] = tagsMap[accountNumberTagsMap[key].tag_id];
        });
        months.forEach(month => {
            month.account_items.forEach(item => {
                const tag = anToTagMap[item.account_number];
                if (tag !== undefined) {
                    item.tag_id = tag.id;
                    // legacy - some places expect the tag to be attached
                    // item.tag = tag;
                }
                else {
                    item.tag_id = null;
                    // item.tag = null;
                    console.error(`no tag found for account number "${item.account_number}"`, item.name);
                }
            });
        });
        return monthOrMonths;
    }
    AccountNumberTagUtils.addTagsToAccountItems = addTagsToAccountItems;
    // separator for base account number and optional tag code suffix
    // e.g. ABCDEFG
    // e.g. ABCDEFG__ISREV
    // e.g. ABCDEFG__a12b3c4b
    const sep = '__';
    function getAccountNumberForTag(accountNumber, tag, accountNumberTags) {
        // find an existing AccountNumberTag matching the base account number and tag
        // may or may not have a tag code suffix (legacy items will have no suffix)
        const existing = accountNumberTags
            .slice()
            .reverse()
            .find(item => {
            return item.account_number.split(sep)[0] === accountNumber && item.tag_id === tag.id;
        });
        if (!!existing) {
            return existing.account_number;
        }
        return `${accountNumber}${sep}${Utils_1.default.generateUuid().slice(0, 13)}`;
    }
    AccountNumberTagUtils.getAccountNumberForTag = getAccountNumberForTag;
    /**
     * Finds the most recent matching, enabled Account Number Tag for an Account Number,
     * ignoring Tag code suffixes
     *
     * @param {string} accountNumber
     * @param {AccountNumberTag[]} accountNumberTags
     * @return {AccountNumberTag | null}
     */
    function getImportAccountNumberTag(accountNumber, accountNumberTags) {
        return accountNumberTags
            .filter(it => !it.Disabled)
            .reverse()
            .find(it => it.account_number.split(sep)[0] === accountNumber) || null;
    }
    AccountNumberTagUtils.getImportAccountNumberTag = getImportAccountNumberTag;
})(AccountNumberTagUtils || (AccountNumberTagUtils = {}));
module.exports = AccountNumberTagUtils;
